import { render, staticRenderFns } from "./RoleAuth.vue?vue&type=template&id=a98e7a20&scoped=true"
import script from "./RoleAuth.vue?vue&type=script&lang=js"
export * from "./RoleAuth.vue?vue&type=script&lang=js"
import style0 from "./RoleAuth.vue?vue&type=style&index=0&id=a98e7a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e7a20",
  null
  
)

export default component.exports